<template>
  <div>
    <v-snackbar
      v-model="snackState"
      :color="snackColor"
      :timeout="snackTime"
      bottom
      right
    >
      {{ statusMessage }}
    </v-snackbar>
  </div>
</template>
<script>
import decode from "jwt-decode";

export default {
  name: "LogOutWarning",
  props: {
    jwtToken: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      snackState: false,
      snackColor: "primary",
      snackText: "",
      snackTime: 10000,
      statusMessage: "Checking status...",
      channel: null, //Instancia de BroadcastChannel()
      messageHandler: null, // EventListener BroadcastChannel()
      notificationIntervals: [300, 240, 180, 120, 60, 0], // Intervalos de notificación en segundos
      setIntervalIds: [], //Lista de IDs de setTimeOut()
    };
  },
  methods: {
    setTimers() {
      const expiracion = decode(this.jwtToken).exp * 1000;
      const today = Date.now();
      const diferencia = (expiracion - today) / 1000;

      this.notificationIntervals.forEach((interval) => {
        const timeOut = (diferencia - interval) * 1000;

        if (interval == 0) {
          const id = setTimeout(() => {
            this.setNotification(interval, true);
          }, timeOut);

          this.setIntervalIds.push(id);
          return;
        }

        if (timeOut > 0) {
          const id = setTimeout(() => {
            this.setNotification(interval);
          }, timeOut);

          this.setIntervalIds.push(id);
        }
      });
    },
    setNotification(interval, logout = false) {
      if (this.channel) {
        if (logout) {
          const tokenExpired = true;
          this.statusMessage = "Su sesión expiró...";

          this.$toast.info(this.statusMessage, {
            position: "top-right",
            pauseOnHover: false,
            closeOnClick: false,
            draggable: false,
            timeout: 2000,
          });

          try {
            this.channel.postMessage({ tokenExpired });
          } catch (error) {
            console.error("Mensaje no fue enviado");
          }

          this.cleanup();
        } else {
          const expiraEn = Math.max(1, Math.ceil(interval / 60));
          this.statusMessage = `Su sesión se cerrará en ${expiraEn} ${
            expiraEn > 1 ? "minutos" : "minuto"
          }...`;

          this.$toast.info(this.statusMessage, {
            position: "top-right",
            pauseOnHover: false,
            closeOnClick: false,
            draggable: false,
            timeout: 10000,
          });
        }
      }
    },
    setBroadcastChannel() {
      try {
        this.channel = new BroadcastChannel("jwt_timer_channel");
        this.messageHandler = (event) => {
          if (event.data && event.data.tokenExpired == true) {
            this.cleanup();
          }
        };
        this.channel.addEventListener("message", this.messageHandler);
      } catch (error) {
        console.error("Error al crear BroadcastChannel:", error);
      }
    },
    cleanup() {
      if (this.setIntervalIds.length > 0) {
        this.setIntervalIds.forEach((id) => clearTimeout(id));
      }

      if (this.channel) {
        this.channel.removeEventListener("message", this.messageHandler);
        this.channel.close();
      }

      this.$store.dispatch("salir");
    },
  },
  created() {
    this.setTimers();
    this.setBroadcastChannel();
  },
  beforeDestroy() {
    this.cleanup();
  },
};
</script>
